import React from 'react';
import { CalendarDays, Sparkles, Mountain, HandHeart, Wallet, Compass, Lock } from 'lucide-react';
import { growthFocusLabel, nextStepText } from '../lib/onboardingContent';

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3 p-3 rounded-arch-lg bg-white/65 dark:bg-white/10 border border-primary/15">
    <span className="w-10 h-10 shrink-0 rounded-2xl flex items-center justify-center text-white" style={{ background: 'linear-gradient(135deg, #4AADA8, #A99CC8)' }}>
      <Icon className="w-5 h-5" aria-hidden="true" />
    </span>
    <span className="min-w-0 flex flex-col">
      <span className="text-[11px] text-text-muted tracking-wide">{label}</span>
      <span className="font-heading font-semibold text-[15px] leading-snug text-text-main">{value}</span>
    </span>
  </div>
);

/* "Your Sirati Path": reflects the member's answers back to them. */
const SiratiPath = ({ answers, onContinue, continueLabel = 'Continue' }) => {
  const { timeline, growth, challenge, support, readiness } = answers;
  return (
    <div data-testid="sirati-path">
      <h2 className="font-heading text-2xl font-semibold text-text-main tracking-tight mb-1">Your Sirati Path</h2>
      <p className="text-base text-text-main mb-5">You're taking a smart step toward marriage readiness.</p>

      <div className="space-y-2 mb-4">
        {timeline && <Row icon={CalendarDays} label="Your marriage timeline" value={timeline} />}
        {growth && <Row icon={Sparkles} label="Your growth focus" value={growthFocusLabel(growth)} />}
        {challenge && <Row icon={Mountain} label="Your current challenge" value={challenge} />}
        {support && <Row icon={HandHeart} label="The support you want" value={support} />}
        {readiness && <Row icon={Wallet} label="Your financial picture" value={readiness} />}
      </div>

      <div className="flex gap-3 p-4 rounded-arch-lg mb-3" style={{ background: 'rgba(169,156,200,0.16)' }}>
        <span className="w-8 h-8 shrink-0 rounded-xl flex items-center justify-center text-white" style={{ background: 'linear-gradient(135deg, #4AADA8, #A99CC8)' }}>
          <Compass className="w-4 h-4" aria-hidden="true" />
        </span>
        <div>
          <p className="text-[11px] text-text-muted">Your next step</p>
          <p className="text-[15px] leading-relaxed text-text-main mt-0.5">{nextStepText(growth, challenge)}</p>
        </div>
      </div>

      <p className="flex items-center gap-1.5 text-xs text-text-muted mb-4">
        <Lock className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
        Only you can see this. It lives on your personal dashboard.
      </p>

      <p className="text-[15px] leading-relaxed text-text-main text-center mb-5">
        You don't have to figure it all out yourself.<br />
        Sirati is here to help you grow, prepare, and navigate the journey with intention.
      </p>

      <button
        type="button"
        onClick={onContinue}
        className="w-full min-h-[48px] py-3 bg-primary text-white rounded-full text-base font-semibold btn-hover active:scale-[0.98]"
        data-testid="sirati-path-continue"
      >
        {continueLabel}
      </button>
    </div>
  );
};

export default SiratiPath;
